"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _Caption = _interopRequireDefault(require("./Caption"));

var _utils = require("../utils"); // import app components


var PostTreeSelect = function PostTreeSelect(props) {
  var _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      value = props.value,
      label = props.label,
      _props$language = props.language,
      language = _props$language === void 0 ? null : _props$language,
      onChange = props.onChange;
  var tree = (0, _react.useMemo)(function () {
    // Filter posts by language. This is only applicable if component is used as parent ID selector
    var filteredPosts = language ? items.filter(function (o) {
      return o.language === language;
    }) : items;
    var treePosts = (0, _utils.createDataTree)(filteredPosts);

    var renderTreeNode = function renderTreeNode(item) {
      return /*#__PURE__*/_react.default.createElement(_antd.TreeSelect.TreeNode, {
        key: item.id,
        value: item.id,
        title: item.title
      }, item.childNodes.map(function (o) {
        return renderTreeNode(o);
      }));
    };

    return /*#__PURE__*/_react.default.createElement(_antd.TreeSelect, {
      showSearch: true,
      treeNodeFilterProp: "title",
      value: value,
      treeDefaultExpandAll: true,
      onChange: onChange,
      getPopupContainer: function getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
      }
    }, /*#__PURE__*/_react.default.createElement(_antd.TreeSelect.TreeNode, {
      value: 0,
      title: "None"
    }), treePosts.map(function (o) {
      return renderTreeNode(o);
    }));
  }, [value]);
  return /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 6
  }, /*#__PURE__*/_react.default.createElement(_Caption.default, {
    children: label
  }), tree);
};

var _default = PostTreeSelect;
exports.default = _default;